import React, { useRef, useState } from 'react';

import { Spinner, Button, Row, Col } from 'reactstrap';

import ReactToPrint from 'react-to-print';

import { useAuth } from '~/context/AuthContext';
import { useClube } from '~/context/ClubeContext';
import { toast } from 'react-hot-toast';
import { fetchDataToPrint } from '~/services/printer/dataToPrint';
import { printHtmlInIframe } from '~/services/printer/printerUtils';
import PersonalButton from '../Buttons/PersonalButton';
import PersonalOutlineButton from '../Buttons/PersonalOutlineButton';
import { useCashMovementsStore } from 'store/cashMovementsStore';

export default function CashierFooterNF({
  session,
  getBillsSession,
  handlePrintItem,
  printClick,
  componentRef,
  setAllTablesAvailable,
  setInputValue,
  setTablesFilteredSearch,
  loadingNfce,
  diferenceValueFunction,
  payments,
  isProcessing,
  setSendUpdateProcessing,
}) {
  const { user } = useAuth();
  const { handlePontuarSession, sessionsAwarded } = useClube();

  const isAblePinpad = user.user_use_pinpad && user.use_pinpad;
  const totalPayment = payments?.reduce(
    (sum, payment) =>
      sum + parseFloat(payment?.payment_value.replace(',', '.')),
    0
  );
  const totalService = parseFloat(
    session?.total_service_price.replace(',', '.')
  );
  const allowCloseTable =
    !(totalService - totalPayment > 0) || totalService - totalPayment === 0;

  const hasCreditRegisterPayment = payments.some((p) => {
    return p?.keyword === 'prazo' || p?.payment_method?.keyword === 'prazo';
  });

  function showNfceFooter() {
    if (user.credit_register_with_nfce) {
      return !hasCreditRegisterPayment;
    }
    return true;
  }

  const iframeRef = useRef(null);
  const handleFetchDataToPrint = async (payload) => {
    try {
      const htmlResponse = await fetchDataToPrint(payload);
      printHtmlInIframe(iframeRef, htmlResponse);
    } catch (error) {
      toast.error('Erro ao buscar dados para impressão');
    }
  };

  const setMovementsCash = useCashMovementsStore(
    (state) => state.setCashMovements
  );

  return (
    <>
      <iframe ref={iframeRef} style={{ display: 'none' }} />
      <div style={{ width: '100%' }}>
        <Row lg="8">
          <Col md="12">
            <div
              style={{
                display: 'flex',
                flexDirection: 'row-reverse',
                justifyContent: 'space-between',
              }}
            >
              {user.has_nfce && showNfceFooter() ? (
                !session.nfce_allowed && (
                  <>
                    <PersonalButton
                      type="submit"
                      id="button_finalizar"
                      message={
                        loadingNfce
                          ? 'Finalizando, aguarde...'
                          : 'Finalizar e Emitir Nota Fiscal'
                      }
                      color="#2EC9B7"
                      disabled={!allowCloseTable && isAblePinpad}
                    />

                    {isProcessing && (
                      <PersonalButton
                        type="submit"
                        color="#229688"
                        id="atualizar_status"
                        onClick={() => setSendUpdateProcessing(true)}
                        message={
                          loadingNfce ? 'Aguarde...' : 'Atualizar status'
                        }
                        disabled={loadingNfce}
                      />
                    )}

                    {session?.table?.table_type === 'delivery' && (
                      <PersonalOutlineButton
                        onClick={() => diferenceValueFunction()}
                        color="#fff"
                        fontColor="#2EC9B7"
                        borderColor="#2EC9B7"
                        disabled={loadingNfce}
                        id="button_finalizar"
                        message={
                          loadingNfce
                            ? 'Finalizando, aguarde ...'
                            : 'Fechar comanda'
                        }
                      />
                    )}
                  </>
                )
              ) : (
                <>
                  {showNfceFooter() && (
                    <PersonalButton
                      onClick={() => {
                        diferenceValueFunction();
                      }}
                      color="#2EC9B7"
                      disabled={loadingNfce}
                      id="button_finalizar"
                      message="Finalizar"
                    />
                  )}

                  {isProcessing && (
                    <PersonalButton
                      type="submit"
                      color="#229688"
                      id="atualizar_status"
                      onClick={() => setSendUpdateProcessing(true)}
                      message={loadingNfce ? 'Aguarde...' : 'Atualizar status'}
                      disabled={loadingNfce}
                    />
                  )}
                </>
              )}

              {user.is_printed_on_web || user.print_bills_on_web ? (
                <PersonalOutlineButton
                  type="button"
                  id="button_fechar"
                  message="Fechar comanda"
                  color="#fff"
                  fontColor="#2EC9B7"
                  borderColor="#2EC9B7"
                  disabled={!session?.key || loadingNfce}
                  onClick={() => {
                    handleFetchDataToPrint({
                      print_type: 'table_session',
                      table_session_id: session.id,
                    }).then(() => {
                      setTimeout(() => {
                        handlePrintItem({
                          session_key: session.key,
                        });
                        setAllTablesAvailable('');
                        setInputValue('');
                        setTablesFilteredSearch('');
                        if (
                          !sessionsAwarded.includes(session.id) &&
                          user.has_clube
                        ) {
                          handlePontuarSession({
                            session_key: session.key || session.session_key,
                          });
                        }
                      }, 1000);
                    });
                  }}
                />
              ) : (
                <>
                  {!loadingNfce && session?.key ? (
                    <PersonalOutlineButton
                      id="button_fechar"
                      message="Fechar comanda"
                      color="#fff"
                      fontColor="#2EC9B7"
                      borderColor="#2EC9B7"
                      onClick={() => {
                        printClick();
                        setMovementsCash(true);
                      }}
                    />
                  ) : (
                    <Button
                      style={{
                        marginTop: 20,
                        background: '#2EC9B7',
                        display: !session?.key && 'none',
                      }}
                      id="button_fechar"
                    >
                      <Spinner
                        style={{ width: '1em', height: '1em' }}
                        color="light"
                      />
                    </Button>
                  )}
                </>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}
